import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const faqs = [
  {
    q: "¿Qué es el RETEF y quién lo concede?",
    a: "El RETEF (Registro de Extractores de Depósitos Fiscales) es un registro creado por el Real Decreto 249/2023 y concedido por la AEAT. Habilita a operar como extractor autorizado de productos sujetos a impuestos especiales sobre alcohol, bebidas derivadas e hidrocarburos.",
  },
  {
    q: "¿Qué es el régimen suspensivo de impuestos especiales?",
    a: "Es el régimen fiscal por el cual los impuestos especiales quedan en suspenso mientras el producto permanece en el depósito fiscal o circula entre depósitos. El impuesto solo se liquida cuando el producto se pone a consumo.",
  },
  {
    q: "¿Podemos operar sin tener el RETEF propio?",
    a: "Sí. Trabajando con FiscalBond como extractor autorizado, tu empresa puede operar en régimen suspensivo sin necesidad de obtener su propio RETEF ni constituir garantías ante la AEAT.",
  },
  {
    q: "¿Qué productos están sujetos a impuestos especiales?",
    a: "Principalmente: hidrocarburos (gasolina, gasóleo, queroseno, fueloil, lubricantes, asfaltos, GLP, nafta) y alcohol y bebidas derivadas (alcohol etílico, bebidas espirituosas, brandy, licores, alcohol industrial, farmacéutico y cosmético).",
  },
  {
    q: "¿Cuánto tiempo lleva empezar a trabajar con vosotros?",
    a: "Tras una reunión inicial de diagnóstico, podemos tener tu operativa diseñada y la documentación lista en pocos días. Las primeras extracciones suelen comenzar en 1-2 semanas.",
  },
  {
    q: "¿En qué comunidades autónomas y países operáis?",
    a: "Operamos en todo el territorio español y, en régimen suspensivo, en todos los Estados miembros de la Unión Europea. También gestionamos exportaciones a terceros países.",
  },
  {
    q: "¿Qué documentación necesita mi empresa para empezar?",
    a: "Lo básico: CIF, escrituras, CAE si lo tienes, alta en IAE relacionada y datos de tu operativa (proveedores, productos, volúmenes). Nosotros nos encargamos del resto.",
  },
  {
    q: "¿Qué ventaja financiera supone el régimen suspensivo?",
    a: "El impuesto sobre hidrocarburos y alcohol representa una parte enorme del precio. Diferir su pago libera liquidez de forma inmediata y mejora drásticamente las necesidades de circulante.",
  },
  {
    q: "¿Es el INCOTERM FOB más beneficioso que el CIF?",
    a: "Depende del caso. FOB suele dar más control y flexibilidad sobre el transporte y la fiscalidad, mientras que CIF simplifica la operativa. En operaciones extracomunitarias triangulares puede ser determinante: lo evaluamos contigo.",
  },
  {
    q: "¿Qué son las operaciones triangulares extracomunitarias?",
    a: "Son compraventas en las que intervienen tres operadores de países distintos (al menos uno extracomunitario) y el producto se mueve directamente entre origen y destino sin pasar por el intermediario. Gestionamos toda la documentación aduanera y fiscal.",
  },
  {
    q: "¿Podéis gestionar reexpediciones a la UE y exportaciones?",
    a: "Sí. Tramitamos reexpediciones intracomunitarias en régimen suspensivo (con EMCS/ARC) y exportaciones a terceros países sin liquidación de impuestos especiales.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-[#F5F7FA] py-24 md:py-32 text-[#1A1A2E]"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <span className="text-xs uppercase tracking-[0.25em] text-[#0066FF] font-semibold">
            Preguntas frecuentes
          </span>
          <h2
            className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold leading-tight"
            style={{ fontFamily: "Poppins" }}
          >
            Resolvemos tus dudas.
          </h2>
          <p className="mt-5 text-slate-700 text-lg">
            Tu competencia ya está optimizando su fiscalidad.{" "}
            <span className="text-[#0A1628] font-semibold">¿Tienes dudas? Las resolvemos.</span>
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="mt-12"
        >
          <Accordion type="single" collapsible className="w-full space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="bg-white border border-slate-200 rounded-2xl px-5 data-[state=open]:border-[#0066FF]/40 data-[state=open]:shadow-lg data-[state=open]:shadow-[#0066FF]/5 transition-all"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left py-5 text-base md:text-lg font-medium text-[#0A1628] hover:no-underline hover:text-[#0066FF]"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed pb-5 text-sm md:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
